import {AppPromoData} from "../identity/member-summary-entity.model";
import {MenuItemData} from "../menu/menu-entity.model";

export class PromoEvent {
    constructor(public promo: AppPromoData,
                public menuItem: MenuItemData) {
    }
}



// WEBPACK FOOTER //
// ./src/app/promo/promo-event.ts